export default __webpack_public_path__ + "static/media/users_openapi.ed81aa0c.yaml";